import React from "react";
import { Skeleton } from "@mui/material";
import { CustomButton, CustomTooltip, icon } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import styles from "./CommitmentRowHeader.module.css";

const CommitmentRowHeader = ({ disabledDelete, launchProgress, selectedTheme, onDeleteCommitment }) => (
	<div className={styles.header}>
		<div className={styles.headerTop}>
			{(launchProgress && <Skeleton height="var(--spacing-l)" variant="rectangular" width="100%" />) || (
				<>
					<h2 className={styles.title}>{selectedTheme}</h2>
					<div className={styles.headerButtons}>
						<CustomTooltip title={translate("commitment-tracking.table.actions.delete")}>
							<span>
								<CustomButton
									color="secondary"
									disabled={disabledDelete}
									startIcon={icon.faTrash}
									variant="outlined"
									onClick={onDeleteCommitment}
								/>
							</span>
						</CustomTooltip>
					</div>
				</>
			)}
		</div>
	</div>
);

export default CommitmentRowHeader;
